module.exports = __webpack_public_path__ + "img/hobbiton-3018-09-24.ffa0701f.jpg";